import { Button, DatePicker, Input } from '@shared/ui/kit';
import { REMOTE_FILTERS } from '@entities/participants';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { DateRange } from '@shared/types/types';
import { SearchIcon, CrossIcon } from '@shared/assets/icons';
import { UnstyledButton } from '@shared/ui/unstyled-button';

interface FilterParticipantsProps {
  inputText: string;
  onChangeSearch: (text: string) => void;
  dateRange: DateRange;
  onChangeDates: (dateRange: DateRange) => void;
  remoteFilter: REMOTE_FILTERS;
  onChangeRemoteFilter: (remoteFilter: REMOTE_FILTERS) => void;
  showFilter: boolean;
}

export const FilterParticipants = ({
  inputText,
  onChangeSearch,
  dateRange,
  onChangeDates,
  remoteFilter,
  onChangeRemoteFilter,
  showFilter,
}: FilterParticipantsProps) => {
  const onChangeDateRange = (date: DateRange) => {
    const isCompleteRange = Boolean(date[0] && date[1]);
    const isCleared = !date[0] && !date[1];

    if (isCompleteRange || isCleared) {
      onChangeDates(date);
    }
  };

  const hasInputText = Boolean(inputText);
  const handleIconClick = hasInputText ? () => onChangeSearch('') : undefined;

  const searchIcon = (
    <i {...stylex.props(styles.searchIcon)}>
      <SearchIcon />
    </i>
  );

  const clearIcon = (
    <i {...stylex.props(styles.crossIcon)}>
      <CrossIcon />
    </i>
  );

  return (
    <div {...stylex.props(styles.filtersContainer)}>
      <div {...stylex.props(styles.filtersTitle)}>Фильтры</div>

      <div {...stylex.props(styles.filters)}>
        <div {...stylex.props(styles.searchInputWrapper)}>
          <Input
            status="default"
            placeholder="Поиск"
            value={inputText}
            size="small"
            settings={{ width: '100%' }}
            changeFunction={onChangeSearch}
          />
          <UnstyledButton onClick={handleIconClick}>{hasInputText ? clearIcon : searchIcon}</UnstyledButton>
        </div>

        {showFilter && (
          <>
            <div {...stylex.props(styles.filter)}>
              <div {...stylex.props(styles.filterFieldset)}>
                <div {...stylex.props(styles.filterTitle)}>Дата выхода на работу</div>
                <div {...stylex.props(styles.filterDescription)}>Первый рабочий день или интервал</div>
              </div>

              <DatePicker
                labelText=""
                size="small"
                selectedDate={new Date()}
                isRange
                selectedRange={dateRange}
                setNewSelectedDate={onChangeDateRange}
              />
            </div>

            <div {...stylex.props(styles.filter)}>
              <div {...stylex.props(styles.filterFieldset)}>
                <div {...stylex.props(styles.filterTitle)}>Формат работы</div>
                <div {...stylex.props(styles.filterDescription)}>Расположение сотрудника</div>
              </div>

              <div {...stylex.props(styles.filterFormatButtons)}>
                <Button
                  variant={remoteFilter === REMOTE_FILTERS.ALL ? 'primary' : 'link'}
                  onClick={() => onChangeRemoteFilter(REMOTE_FILTERS.ALL)}
                  size="small"
                >
                  Любой
                </Button>
                <Button
                  variant={remoteFilter === REMOTE_FILTERS.REMOTE ? 'primary' : 'link'}
                  onClick={() => onChangeRemoteFilter(REMOTE_FILTERS.REMOTE)}
                  size="small"
                >
                  Удаленно
                </Button>
                <Button
                  variant={remoteFilter === REMOTE_FILTERS.OFFICE ? 'primary' : 'link'}
                  onClick={() => onChangeRemoteFilter(REMOTE_FILTERS.OFFICE)}
                  size="small"
                >
                  Офис
                </Button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
